import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppBarrageGameOverviewVO } from '../Type/PackEntityAppBarrageGameOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询应用当前的弹幕游戏总览信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用ID
 * @param {string} [data.cid] 企业ID
 */

export function funcbarrageGameoverview(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityAppBarrageGameOverviewVO>
export function funcbarrageGameoverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityAppBarrageGameOverviewVO extends { msg: unknown } ? PackEntityAppBarrageGameOverviewVO['msg'] : undefined
>
export function funcbarrageGameoverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/barrageGame/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
